import { render, staticRenderFns } from "./PurchasePage.vue?vue&type=template&id=99fa8632&"
import script from "./PurchasePage.vue?vue&type=script&lang=js&"
export * from "./PurchasePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports